<template>
  <div class="h-100">
    <main role="main" class="h-100">
      <common-master-table
        primary-key="taskHstSerialId"
        table-no="trTaskHst"
        table-api="work/taskhst"
        ref="commonMasterTable"
        :mapping-no="`ie-taskhst`"
        :displayDialogViewDetail="true"
        :hideSaveToAction="true"
        :hideDeleteToAction="true"
        :hideChbxColumn="true"
        :hideChbxAllColumn="true"
        :hideFirstColHeader="true"
        :hideButtonImportCsv="true"
        :hideButtonAdd="true"
        :hideEditButton="true"
        :hideDeleteButton="true"
        :hideButtonDeleteAll="true"
        :showLockMasterButton="false"
        socket-entity="TASK_HISTORY_SOCKET"
      />
    </main>
  </div>
</template>

<script>
import CommonMasterTable from '../custom-components/CommonMasterTable'
import RouterUtils from '../../_helpers/router.util'
export default {
  components: {
    // コンポーネント分割化
    CommonMasterTable
  },
  data() {
    return {
      tableNo: 'trTaskHst',
      updateQueryStr: ''
    }
  },
  beforeRouteUpdate(to, from) {
    if (to.query && to.query.hasOwnProperty('limit') && Object.keys(to.query).length === 1) {
      RouterUtils.correctTableRowsLimitParam(to.query)
      this.$refs.commonMasterTable.initData()
    }
  },
  methods: {}
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/mst-tables/TaskHistory.vue